// FIX: Correct import path for PROPERTY_TYPE_MAP
import { PROPERTY_TYPE_MAP } from './utils/propertyTypes';


// ─────────────────────────────
// Geeft max 2 unieke plaatsnamen, met '...' als er meer zijn

// HELPERS
// ─────────────────────────────

// Extract surface number
function extractSurfaceNumber(superficie) {
  if (typeof superficie === "number") return superficie;
  if (typeof superficie !== "string") return null;
  const nums = superficie.match(/\d+/g);
  if (!nums) return null;
  if (nums.length >= 2) {
    return Math.round((+nums[0] + +nums[1]) / 2);
  }
  return Number(nums[0]);
}

// Normalize accents + lowercase
function normalizeText(str) {
  return str
    ?.normalize("NFD")
    ?.replace(/[\u0300-\u036f]/g, "")
    ?.toLowerCase();
}

// Surface ranges
const SURFACE_RANGES = {
  Piso: [
    { min: 0, max: 50 },
    { min: 51, max: 80 },
    { min: 81, max: 120 },
    { min: 121, max: 180 },
    { min: 181, max: 350 },
    { min: 351, max: 500 },
    { min: 501, max: 1000 },
  ],
};

function normalizeSurface(surface, propertyType) {
  const s = Number(surface);
  if (!Number.isFinite(s)) return null;
  const ranges = SURFACE_RANGES[propertyType];
  if (!ranges) return s;
  const r = ranges.find(x => s >= x.min && s <= x.max);
  return r ? Math.floor((r.min + r.max) / 2) : s;
}

    // Render advisor cards identiek aan ComparePage.js
    function renderAdvisors(companies) {
  const resultsContainer = document.getElementById("results");
  if (!resultsContainer) return;

  resultsContainer.innerHTML = companies.map(advisor => {
    const rating = advisor?.rating || 4.7;
    const stars = Math.round(rating);
    const emptyStars = 5 - stars;
    const starSvg = '<svg class="w-4 h-4 fill-current text-yellow-400" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
    const emptyStarSvg = '<svg class="w-4 h-4 fill-current text-gray-300" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
    const allStars = Array(stars).fill(starSvg).concat(Array(emptyStars).fill(emptyStarSvg)).join("");
    const partnerId = encodeURIComponent(
      advisor?.company?.toLowerCase()?.replace(/\s+/g, "-") || "unknown-advisor",
    );

    //  (API = epcspainhomes.com, assets = ceecasasespana.com)
    const LOGO_BASE_URL = "https://ceecasasespana.com";

    const logoUrl = (() => {
      const logo = advisor?.logo?.trim();

      if (!logo) {
        return `${LOGO_BASE_URL}/logos/LogoES.webp`;
      }

      // Absolute URL → gebruiken zoals hij is
      if (logo.startsWith("http")) {
        return logo;
      }

      // Relatief pad → prefixen
      return `${LOGO_BASE_URL}${logo}`;
    })();

    let currentPrice = null;
    let deliveryDays = null;
    if (advisor?.matched_price?.price) {
      currentPrice = Number(advisor.matched_price.price);
      deliveryDays = advisor.matched_price.delivery_days;
    }

    // Determine card background color based on role
    const isAdmin = advisor?.role === 'admin';
    const cardBgClass = isAdmin ? 'bg-gray-200' : 'bg-white';

    return `
      <div class="partner-card ${cardBgClass} rounded-lg border border-gray-200 p-4 hover:shadow-lg transition-shadow duration-300 mb-4" data-partner-id="${partnerId}">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-4 flex-1">
              <img src="${logoUrl}" alt="${advisor?.company || 'Advisor'} logo" class="w-16 h-16 object-contain" />
              <div class="flex-1">
                <div class="flex items-center gap-6 mb-2">
                  <h3 class="text-lg font-bold text-gray-900">Company</h3>
                  <span class="text-sm text-gray-700">Rating:</span>
                  <span class="flex items-center gap-1">
                    ${allStars}
                    <span class="text-lg font-semibold text-gray-900">${rating}</span>
                  </span>
                </div>
                <h3 class="text-lg font-semibold text-gray-900 mb-2">${advisor?.company || 'Unknown company'}</h3>
                
                <div class="flex gap-4 mt-3">
                  <button class="text-sm px-3 py-1 border border-gray-300 rounded hover:bg-gray-50" 
                      onclick="toggleAdvisorInfo('${partnerId}', 'about')" 
                      id="tab-about-${partnerId}">
                    About the advisor ↓
                  </button>
                  <button class="text-sm px-3 py-1 border border-gray-300 rounded hover:bg-gray-50" 
                      onclick="toggleAdvisorInfo('${partnerId}', 'reviews')" 
                      id="tab-reviews-${partnerId}">
                    Customer reviews ↓
                  </button>
                </div>
              </div>
            </div>
            <div class="flex flex-col items-end gap-3 ml-4">
              <div class="text-right">
                ${currentPrice !== null ? `
                  <div class="flex items-baseline gap-2">
                    <span class="text-gray-900 font-semibold">
                        ${currentPrice.toFixed(2).replace('.', ',')}<span class="text-sm text-gray-700">€ + VAT (21%)<br>
                        <span class="text-sm text-gray-700">Total: ${(currentPrice * 1.21).toFixed(2).replace('.', ',')}€</span>
                    </span>
                  </div>
                  <span class="text-xs text-gray-500">
                    Delivery in ${deliveryDays} business day(s)
                  </span>
                ` : `
                  <span class="text-gray-500 text-sm italic">
                    Price on request
                  </span>
                `}
              </div>
          <button class="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded font-semibold text-sm transition-colors"
            onclick="selectPartner('${partnerId}')">
            Request
          </button>
            </div>
          </div>
          <div id="advisor-content-${partnerId}" class="hidden mt-4 pt-4 border-t border-gray-200">
            <div id="about-content-${partnerId}" class="hidden"></div>
            <div id="reviews-content-${partnerId}" class="hidden"></div>
          </div>
        </div>
      `;
    }).join("");
  }

window.sortAdvisors = function (type) {
  if (!Array.isArray(window.companies)) return;

  const sorted = [...window.companies].sort((a, b) => {
    const priceA = a?.matched_price?.price ?? Infinity;
    const priceB = b?.matched_price?.price ?? Infinity;
    const deliveryA = a?.matched_price?.delivery_days ?? Infinity;
    const deliveryB = b?.matched_price?.delivery_days ?? Infinity;

    if (type === "price") return priceA - priceB;
    if (type === "delivery") return deliveryA - deliveryB;
    return 0;
  });

  renderAdvisors(sorted);
};



export function ComparePagePost() {
  return `

    <div class="hero">
      <div class="hero-content">
        <h1 id="page-title" class="hero-title">Our Energy Certificate Advisors</h1>
        <p class="hero-subtitle">
          Compare our certified partners by price and service to make the best decision for your energy certificate.
        </p>
      </div>
    </div>
    <section class="section bg-gray-50">
      <div class="container">
        <div class="max-w-6xl mx-auto flex flex-col md:flex-row gap-8">

          <!-- Left Column (1/3 width): Property Results -->
          <div class="w-full md:w-1/3">
            <!-- Property Search Results Container -->
            <div id="property-results-section" class="bg-white rounded-lg shadow-md border border-gray-200 p-6 mb-6">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">Your <span class="text-lg font-bold text-gray-800 mb-4">data</span></h3>
              <div id="property-results-content">
                <p class="text-gray-600 text-sm">No results available. Please search for a property first using the form on the main page.</p>
              </div>
              <!-- Info box: What am I requesting -->
              <div class="max-w-md rounded-lg border border-gray-200 bg-gray-50 p-6 mt-6">
                <p class="font-semibold text-gray-900 mb-3">
                  What am I requesting:
                </p>
                <p class="text-gray-800 mb-4">
                  Energy Certification
                </p>
                <div class="space-y-3 text-sm text-gray-700 leading-relaxed">
                  <p>
                    <span class="font-semibold">1st- Visit to the property</span> for inspection. Duration approx. 30 minutes.
                  </p>
                  <p>
                    <span class="font-semibold">2nd- Preparation of the energy certificate.</span>
                    Timeframe approx. 1 or 2 days.
                  </p>
                  <p>
                    <span class="font-semibold">3rd- Registration</span> and payment of fees if applicable at the relevant official body.
                  </p>
                  <p>
                    <span class="font-semibold">4th- Issuance of the energy label</span> by the administration.
                  </p>
                  <p>
                    <span class="font-semibold">5th- Sending</span> of the documentation via email.
                  </p>
                </div>
              </div>
              <!-- Extra info card: More information about -->
              <div class="max-w-md rounded-xl border border-gray-200 bg-white p-6 mt-4">
                <h2 class="text-base font-semibold text-gray-900 mb-2">
                  More information about:
                </h2>
                <p class="text-gray-800 mb-3">
                  Energy Certification
                </p>
                <p class="text-sm text-gray-700 leading-relaxed mb-4">
                  The energy certificate
                  <span class="font-semibold">
                    is essential for selling or renting a property
                  </span>
                  and provides information about the energy consumption and CO2 emissions of a property.
                  <span class="font-semibold">
                    They are valid for 10 years.
                  </span>
                </p>
                <a
                  href="/faq-customer/"
                  class="text-sm font-semibold text-green-600 hover:text-green-700 transition"
                >
                  Read more
                </a>
              </div>
              <!-- Málaga municipios dropdown -->
              <div id="malaga-municipios-dropdown-container" class="mb-6 w-full">
                <!-- Dropdown will be rendered here if Málaga is selected -->
              </div>
            </div>
            <div class="bg-transparent border-transparent shadow-none rounded-lg mb-6" style="min-height:120px; padding:0;"></div>
          </div>

          <!-- Right Column (2/3 width): Advisors section -->
          <div class="w-full md:w-2/3 mt-8 md:mt-0">
            <!-- Advisors heading & filters -->
            <div class="mb-6 flex items-center justify-between">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">Available Advisors</h3>
              <!-- Sorting/filter UI removed, filtering is only backend -->
            </div>

<!-- Filters -->
<div class="bg-white border border-gray-200 rounded-lg p-4 mb-6">
  <div class="flex flex-wrap gap-3 items-center">
    <span class="text-sm font-semibold text-gray-700">Ordenar por:</span>

    <button
      onclick="sortAdvisors('price')"
      class="px-3 py-1 text-sm border rounded hover:bg-gray-100">
      💶 Precio más bajo
    </button>

    <button
      onclick="sortAdvisors('delivery')"
      class="px-3 py-1 text-sm border rounded hover:bg-gray-100">
      ⚡ Entrega más rápida
    </button>
  </div>
</div>

            <!-- Advisor results list -->
            <div id="results" class="space-y-4 mt-4"></div>
          </div>
        </div>
    </section>
    
  `;
}

export async function initializeComparePagePost() {
  const content = document.getElementById("property-results-content");
  if (!content) return;

  const raw = sessionStorage.getItem("propertySearchDataPost");
  if (!raw) {
    content.innerHTML = `<p>No data available.</p>`;
    return;
  }

   

  const data = JSON.parse(raw);
   
  // ✅ Zorg dat BookEPC altijd dezelfde data krijgt
try {
  const completePropertyData = {
    ...data,
    timestamp: Date.now(),
    source: 'compare-page-post'
  };

  // 🔑 ENIGE waarheid voor vervolgpagina’s
  //localStorage.setItem(
   // 'bookingPropertyData',
   // JSON.stringify(completePropertyData)
  //);

  // Optional: sessionStorage synchroon houden
  sessionStorage.setItem(
    'bookingPropertyData',
    JSON.stringify(completePropertyData)
  );

  console.log('[ComparePagePost] bookingPropertyData opgeslagen');
} catch (e) {
  console.warn('[ComparePagePost] Opslaan property data mislukt', e);
}


  // Try multiple keys for compatibility
  let buildingType = data.buildingType || data.tipo || data.type || '';
  let serviceType = data.serviceType || data.servicio || data.service || '';
  // Fallbacks for empty/undefined values
  if (!buildingType || buildingType === '' || buildingType === 'undefined' || buildingType === 'null') {
    buildingType = 'No especificado';
  }
  if (!serviceType || serviceType === '' || serviceType === 'undefined' || serviceType === 'null') {
    serviceType = 'No especificado';
  }

// Zonas de trabajo netjes tonen, max 4 woorden, dan een +
let zonasValue = data.municipios;
if (Array.isArray(zonasValue)) {
  zonasValue = zonasValue.join(", ");
}
if (typeof zonasValue === "string" && zonasValue.trim() !== "") {
  // Split on comma or whitespace, keep first 4, then join
  const words = zonasValue.split(/\s*,\s*|\s+/).filter(Boolean);
  if (words.length > 4) {
    zonasValue = words.slice(0, 4).join(", ") + " +";
  } else {
    zonasValue = words.join(", ");
  }
}

  content.innerHTML = `
  <div class="border-b pb-4 mb-4">
    <div class="mb-3">
      <div class="text-sm"><strong>Building type:</strong> <span class="text-gray-600">${buildingType}</span></div>
      <div class="text-sm"><strong>Service type:</strong> <span class="text-gray-600">${serviceType}</span></div>
    </div>
  </div>
  <table class="text-sm">
    <tr><td>Type</td><td>${data.tipo || "-"}</td></tr>
    <tr><td>Surface</td><td>${data.superficie || "-"}</td></tr>
    <tr><td>Postal code</td><td>${data.codigo_postal || "-"}</td></tr>
    <tr><td>Province</td><td>${data.provincia || data.province || "-"}</td></tr>
    <tr><td>Work area</td><td>${zonasValue || "-"}</td></tr>
  </table>
`;



  // 🔥 HIER GEBEURT HET
  await filterAdvisorsByPropertyLocation(data);
}

// ─────────────────────────────
// API CALL (1×)
// ─────────────────────────────

export async function filterAdvisorsByPropertyLocation(propertyData) {
  const resultsContainer = document.getElementById("results");
  if (!resultsContainer) return;

  // ── PAYLOAD
  const payload = {};

if (propertyData.provincia || propertyData.province) {
  payload.province = normalizeText(
    propertyData.provincia || propertyData.province
  );
}

// 👇 HIER TOEVOEGEN
if (Array.isArray(propertyData.municipios) && propertyData.municipios.length) {
  payload.city = propertyData.municipios
    .map(c => normalizeText(c))
    .join(",");
}

if (propertyData.tipo) {
  payload.property_type =
    PROPERTY_TYPE_MAP[propertyData.tipo] || propertyData.tipo;
}

  if (propertyData.superficie && payload.property_type) {
    const s = extractSurfaceNumber(propertyData.superficie);
    if (Number.isFinite(s)) {
      payload.surface = normalizeSurface(s, payload.property_type);
    }
  }

  

  // UI loading
  resultsContainer.innerHTML = `
    <p class="text-gray-500">Searching for advisors in ${payload.province}…</p>
  `;

try {
  // Detecteer dev server (Vite: 5173, 4173, 4174, etc.)
  const isDev =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    ["4000", "4174", "5173"].includes(window.location.port);

  const baseUrl = isDev ? "http://localhost:4000" : "";

  const params = new URLSearchParams(payload).toString();
  const res = await fetch(`${baseUrl}/api/companies?${params}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
    credentials: "include",
  });

  if (!res.ok) throw new Error("Fetch failed");

  const companies = await res.json();
  window.companies = companies;

  if (!companies.length) {
    resultsContainer.innerHTML =
      `<p class="text-gray-500">No advisors found.</p>`;
    return;
  }

 renderAdvisors(companies); // 👈 VERPLICHT

// Toggle voor "Over adviseur" / "Klantervaringen" identiek aan ComparePage.js
window.toggleAdvisorInfo = function (partnerId, tabType) {
  const contentDiv = document.getElementById(`advisor-content-${partnerId}`);
  const aboutContent = document.getElementById(`about-content-${partnerId}`);
  const reviewsContent = document.getElementById(`reviews-content-${partnerId}`);
  const aboutTab = document.getElementById(`tab-about-${partnerId}`);
  const reviewsTab = document.getElementById(`tab-reviews-${partnerId}`);

  const wasAboutVisible = !aboutContent.classList.contains("hidden");
  const wasReviewsVisible = !reviewsContent.classList.contains("hidden");

  // Reset alles
  aboutContent.classList.add("hidden");
  reviewsContent.classList.add("hidden");
  aboutTab.classList.remove("bg-gray-100", "font-medium");
  reviewsTab.classList.remove("bg-gray-100", "font-medium");

  if (
    (tabType === "about" && wasAboutVisible) ||
    (tabType === "reviews" && wasReviewsVisible)
  ) {
    contentDiv.classList.add("hidden");
    return;
  }

  contentDiv.classList.remove("hidden");

  if (tabType === "about") {
    // Find advisor data
    const advisor = window.companies.find(
      (a) =>
        encodeURIComponent(
          a.company?.toLowerCase().replace(/\s+/g, "-") || "",
        ) === partnerId,
    );
    aboutContent.innerHTML = `
      <h4 class="font-semibold text-gray-900 mb-2">About ${advisor?.company || partnerId}</h4>
      <p class="text-sm text-gray-600">${advisor?.description ? advisor.description : "No description available."}</p>
    `;
    aboutContent.classList.remove("hidden");
    aboutTab.classList.add("bg-gray-100", "font-medium");
  } else {
    // Find advisor index for rating
    const index = window.companies.findIndex(
      (a) =>
        encodeURIComponent(
          a.company?.toLowerCase().replace(/\s+/g, "-") || "",
        ) === partnerId,
    );
    const rating = window.companies[index]?.rating || 3.6;
    const reviews = window.companies[index]?.reviews || 29;
    const stars = Math.round(rating);

    const starSvg =
      '<svg class="w-4 h-4 fill-current text-yellow-400" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
    const emptyStarSvg =
      '<svg class="w-4 h-4 fill-current text-gray-300" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
    const allStars = Array(stars)
      .fill(starSvg)
      .concat(Array(5 - stars).fill(emptyStarSvg))
      .join("");

    reviewsContent.innerHTML = `
      <h4 class="font-semibold text-gray-900 mb-4">Customer reviews</h4>
      <div class="bg-gray-50 p-4 rounded-lg">
        <div class="flex items-center mb-3">
          <div class="flex">${allStars}</div>
          <span class="ml-3 text-lg font-semibold">${rating}</span>
          <span class="ml-2 text-sm text-gray-600">(${reviews})</span>
        </div>
        <p class="text-sm text-gray-600 italic mb-2">
          "Fast service and professional assessment. The energy certificate was delivered exactly within the promised timeframe."
        </p>
        <p class="text-xs text-gray-500">- Verified customer</p>
      </div>
    `;
    reviewsContent.classList.remove("hidden");
    reviewsTab.classList.add("bg-gray-100", "font-medium");
  }
};


window.resetAdvisorAndGo = function () {
  console.log('[ComparePagePost] Team selected');

  sessionStorage.setItem(
    'selectedAdvisorData',
    JSON.stringify({
      company: 'Team CEE Casas España'
    })
  );

  window.location.href = '/book-epc/';
};


  } catch (err) {
    console.error(err);
    resultsContainer.innerHTML =
      `<p class="text-gray-500">No advisors found.</p>`;
  }
}